import { createReducer } from 'typesafe-actions';
import { get } from '../../../common/utils/objectUtils';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { fetchProductReviewsActions, ProductReviewsActionsType } from './action';
import { ProductReview, ProductReviewsState, RawReviewData } from './types';

const mapResponseToReview = (review: RawReviewData): ProductReview => {
    return {
        ...review,
        image: {
            altTag: get(review, 'image.alt_tag', ''),
            path: get(review, 'image.path', ''),
            seoUrl: get(review, 'image.seo_url', ''),
            tag: get(review, 'image.tag', ''),
        },
        author: {
            ...review.author,
            username: review.author.username,
            anonymousName: review.author.anonymous_name,
            isAnonymous: review.author.is_anonymous,
        },
    };
};

export const defaultProductReviewState: ProductReviewsState = {
    didInvalidate: false,
    identifier: '',
    isFetching: false,
    reviews: [],
    totalReviews: 0,
};

export const productReviewsReducer = createReducer<ProductReviewsState, ProductReviewsActionsType>(
    defaultProductReviewState
)
    .handleAction(fetchProductReviewsActions.success, (state, action) => {
        const { data, identifier, reducerPayloadOptions } = action.payload;
        const { sku, urlKey } = reducerPayloadOptions || { sku: '', urlKey: '' };
        const stateSku = (state.reducerPayloadOptions || { sku: '' }).sku;
        const alreadyLoadedReviews = [...state.reviews];
        const apiReviews = get(data, 'data.reviews', []).map(mapResponseToReview);
        const totalReviews = get(data, 'data.meta.total_reviews', 0);
        // Conditions for adding reviews to existing
        // 1) sku === statesku - request comes from pagination request as it has sku
        // this previously had statesku and requires has more review for same SKU
        // 2) stateSKU === '' - first pagination call after SS reviews, stateSKU is still blank
        // 3) urlKey === '' - the call is client side via pagination (maybe just this condition would be enough ¯\_(ツ)_/¯)
        const reviews =
            (sku === stateSku || stateSku === '') && urlKey === ''
                ? [...alreadyLoadedReviews, ...apiReviews]
                : apiReviews;
        return {
            ...state,
            identifier,
            isFetching: false,
            didInvalidate: false,
            reviews,
            reducerPayloadOptions: {
                sku,
            },
            totalReviews,
        };
    })
    .handleAction(fetchProductReviewsActions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(fetchProductReviewsActions.request, (state, action) => defaultRequestHandler(state, action));
